import { Country } from '@prisma/client';

export type CreateCredentialProps = {
  internalIdentifier?: string;
  name?: string;

  jurisdiction?: string;
  credentialType: CredentialType;

  notes?: string;

  portalURL?: string;

  blocks: {
    key: string;
    type: CredentialBlockType;
    value: string;
    isCustomBlock: boolean;
  }[];

  country: Country;
};

export enum CredentialBlockType {
  PlainText = 'PlainText',
  SecureString = 'SecureString',
}

export enum CredentialType {
  CORPORATE_TAX = 'CORPORATE_TAX',
  INDIRECT_TAX = 'INDIRECT_TAX',
  PAYROLL_TAX = 'PAYROLL_TAX',
  COMPANY_SECRETARIAL = 'COMPANY_SECRETARIAL',
  SOCIAL_SECURITY = 'SOCIAL_SECURITY',
  BANKING = 'BANKING',
  OTHER = 'OTHER',
}

export type ICredentialBlock = {
  key: string;
  type: CredentialBlockType;
  value: string | null;
  secretMask: string | null;
  isCustomBlock: boolean;
  id: string;
};

export enum CredentialStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
}

export type ICredential = {
  id: string;
  credentialType: CredentialType;
  jurisdiction: string | null;
  internalIdentifier: string;
  blocks: ICredentialBlock[];
  name: string;
  notes: string;
  portalURL: string;
  createdAt: Date;
  updatedAt: Date;
  status: CredentialStatus;
  lastUpdatedAt: string;
  isCustom: boolean;
  country: Country;
  isUsed?: boolean;
  registrations?: {
    registrationId: string;
    registrationIdentifier: string;
    registrationName: string;
  }[];
};

export type TSupportedCredential = {
  jurisdiction: string;
  internalIdentifier: string;
  credentialType: CredentialType;
  blockName: string;
  blockType: CredentialBlockType;
  portalURL: string;
  name: string;
  country: Country;
};

export type TUpdateCredentialBlockProps = {
  id: string;
  value: string;
};

export type TUpdateCredentialProps = {
  notes?: string;
  blocks?: TUpdateCredentialBlockProps[];
  name?: string;
  portalURL?: string;
  blocksToDelete?: string[];
};

export enum CredentialsGetExtensibleFields {
  SECRETS = 'SECRETS',
  REGISTRATIONS = 'REGISTRATIONS',
}
